// export default {
//   API_URL: window.location.origin.includes("localhost")
//     ? "http://localhost:8000/api"
//     : "https://devapi1.myuni.pk/api",
//   API_HOME: window.location.origin.includes("localhost")
//     ? "http://localhost:8000"
//     : "https://devapi1.myuni.pk/public",
// };

export default {
  // API_URL: window.location.origin.includes("localhost")
  //   ? "http://localhost:8000/api"
  //   : "https://devapi1.myuni.pk/api",
  // API_HOME: window.location.origin.includes("localhost")
  //   ? "http://localhost:8000"
  //   : "https://devapi1.myuni.pk/public",
  //   API_URL: "https://devapi1.myuni.pk/api",
  //   API_HOME: "https://devapi1.myuni.pk/public",
  API_URL: process.env.VUE_APP_API_URL,
  API_HOME: process.env.VUE_APP_API_HOME,
  API_JOB4U: process.env.VUE_APP_API_JOB4U,
};
